import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from '@proman/rxjs-common';

import { Currency } from '../../interfaces/entity-interfaces';
import { Entity } from '../../services/entity.service';
import { CurrencyActions, setCurrency } from './currency.actions';
@Injectable()
export class CurrencyEffects {
    private Entity = inject(Entity);
    private store = inject(Store);
    private actions$ = inject(Actions);

    loadCurrencies$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CurrencyActions.LoadCurrency),
                tap(() => {
                    this.Entity.get('currency')
                        .search()
                        .then((payload: Currency[]) => {
                            this.store.dispatch(setCurrency({ payload }));
                        });
                })
            ),
        { dispatch: false }
    );
}
